import React from "react";
import Why_01 from '../../../assets/images/why-choose/why-choose-six-icon.svg';
const WhyChooseSix=()=>{
    return(
        <div className="why-choose-section-six">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 m-auto">
              <div className="heading-box text-center light">
                <span
                  className="sub-title animate fadeInUp wow animated"
                  data-wow-duration="1500ms"
                >
                  Why Choos Us
                </span>
                <h2
                  className="heading-title animate fadeInUp wow animated"
                  data-wow-duration="1500ms"
                  data-wow-delay="200ms"
                >
                  Strong values that bring great people together.
                </h2>
              </div>
            </div>
          </div>
          <div className="row gutter-y-30">
            <div className="col-lg-4 col-md-6">
              <div
                className="why-choose-box-six animate fadeInUp wow animated"
                data-wow-duration="1500ms"
                data-wow-delay="200ms"
              >
                <div className="why-choose-icon-six">
                  <img
                    src={Why_01}
                    alt="icon"
                  />
                </div>
                <div className="why-choose-details-six">
                  <h4>Best quality</h4>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus
                    pharetra tortor eget lacus ullamcorper.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="why-choose-box-six animate fadeInUp wow animated"
                data-wow-duration="1500ms"
                data-wow-delay="400ms"
              >
                <div className="why-choose-icon-six">
                  <img
                    src={Why_01}
                    alt="icon"
                  />
                </div>
                <div className="why-choose-details-six">
                  <h4>100% safe &amp; secure</h4>
                  <p>
                    We have an ambitious road ahead, and we’re looking for people to
                    join our global team.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div
                className="why-choose-box-six animate fadeInUp wow animated"
                data-wow-duration="1500ms"
                data-wow-delay="600ms"
              >
                <div className="why-choose-icon-six">
                  <img
                    src={Why_01}
                    alt="icon"
                  />
                </div>
                <div className="why-choose-details-six">
                  <h4>Team Collaboration</h4>
                  <p>
                    We stay up-to-date with the latest technology trends and offer
                    innovative solutions that help you stay.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    )
}
export default WhyChooseSix;